import * as tokens from '@utmost.co/utmost-design-tokens';
import { Components } from '../../../styles';
import { OverridesStyleRules } from '@mui/material/styles/overrides';

const labelStyle: OverridesStyleRules = {
  position: 'relative',
  transform: 'none',
  color: tokens.colorOnSurface,
  fontSize: 14,
  fontWeight: 500,
  marginBottom: 0,
  '&.bp-align-top': {
    alignItems: 'flex-start',
    '.MuiCheckbox-root': {
      top: -11
    },
    '&.bp-label-placement-top, &.bp-label-placement-bottom': {
      alignItems: 'center'
    }
  },
  '&.bp-align-bottom': {
    alignItems: 'flex-end',
    '.MuiCheckbox-root': {
      bottom: -11
    },
    '&.bp-label-placement-top, &.bp-label-placement-bottom': {
      alignItems: 'center'
    }
  },
  '&.Mui-focused': {
    color: tokens.colorPrimary
  },
  '&:focus': {
    color: tokens.colorPrimary
  },
  // sub label
  '&.Mui-focused .MuiTypography-root': {
    color: tokens.colorPrimary
  },
  '.MuiTypography-root': {
    transition: 'all 0.25s ease-in-out'
  },
  '&.MuiInputLabel-shrink': {
    transform: 'none'
  },
  '&.Mui-disabled': {
    color: '#1A1A1A'
  }
};

export const labelTheme = {
  MuiFormControlLabel: {
    styleOverrides: {
      asterisk: {
        color: tokens.colorAlert
      },
      root: labelStyle
    }
  },
  MuiFormLabel: {
    styleOverrides: {
      asterisk: {
        color: tokens.colorAlert
      },
      root: labelStyle
    }
  },
  MuiInputLabel: {
    styleOverrides: {
      asterisk: {
        color: tokens.colorAlert
      },
      root: labelStyle
    }
  }
} satisfies Components;
